<template>
  <div class="letter-animation-container" :style="{ fontSize: fontSize }">
    <span
      v-for="(char, index) in chars"
      :key="index"
      class="letter"
      :style="{
        animationDelay: `${index * delayPerChar}s`,
        animationDuration: `${duration}s`
      }"
    >
      {{ char }}
    </span>
  </div>
</template>

<script setup>
// 可配置参数进行设定
const props = defineProps({
  text: {
    type: String,
    default: 'ABCD'          // 默认显示的文本
  },
  delayPerChar: {
    type: Number,
    default: 0.15            // 每个字母之间的延迟间隔（秒）
  },
  duration: {
    type: Number,
    default: 0.6             // 每个字母动画持续时长（秒）
  },
  fontSize: {
    type: String,
    default: '4rem'          // 字体大小，默认保持原样
  }
})

// 将字符串拆分成单个字符数组
const chars = props.text.split('')
</script>

<style scoped>
.letter-animation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-family: sans-serif;
  gap: 0.1em;               /* 字母间距 */
}

.letter {
  display: inline-block;
  opacity: 0;               /* 初始透明，动画开始后渐显 */
  transform: translateX(-50px) rotate(-180deg); /* 初始位置在右侧且旋转180° */
  /*反方向旋转就这样： transform: translateX(50px) rotate(180deg);注意要修改@keyframes letterAppear */
  animation: letterAppear forwards;
  /* animation 的 duration 和 delay 由行内 style 动态设置 */
}

@keyframes letterAppear {
  0% {
    opacity: 0;
    transform: translateX(-50px) rotate(-180deg);
  }
  100% {
    opacity: 1;
    transform: translateX(0) rotate(0deg);
  }
}
</style>